import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import CreatePostBanner from "../components/common/Banners/CreatePostBanner";
import BenefitsRow from "../sections/CreatePost/BenefitsRow";
import CreatePostTextSections from "../sections/CreatePost/CreatePostTextSections";
import UserReviews from "../sections/CreatePost/UserReviews";
import Login from "../sections/Login/Login";
import { SignUp as SignUpRegister } from "../sections/SignUp/SignUp";
import useAuth from "../Hooks/useAuth";

const CreatePost = () => {
  const [SignUp, setSignUp] = useState(false);
  const [SignIn, setSignIn] = useState(false);
  const navigate = useNavigate();
  const { auth } = useAuth();
  
  useEffect(() => {
    if (SignUp) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "visible";
      document.body.style.width = `auto`;
    }
  }, [SignUp]);

  const handleCreatePostClick = () => {
    if (auth?.user) {
      // User is logged in, navigate to business dashboard
      navigate("/business-dashboard/posts/create-post");
    } else {
      // User is not logged in, show signup modal
      setSignUp(true);
    }
  };

  return (
    <>
      <CreatePostBanner
        headingClasses={
          "text-center sm:text-center text-white xl:w-[900px] 2xl:w-[700px] mx-auto pt-38"
        }
        heading={
          "Put your skills to work"
        }
        className={"bg-about"}
        onButtonClick={handleCreatePostClick}
      >
      </CreatePostBanner>
      
      <BenefitsRow />
      <CreatePostTextSections />
      <UserReviews />
      
      {SignIn && (
        <Login
          SignIn={SignIn}
          setSignIn={setSignIn}
          SignUpState={SignUp}
          setSignUpState={setSignUp}
        />
      )}
      {SignUp && (
        <SignUpRegister
          SignUpState={SignUp}
          setSignUpState={setSignUp}
          SignIn={SignIn}
          setSignIn={setSignIn}
        />
      )}
    </>
  );
};

export default CreatePost;
